export default __webpack_public_path__ + "static/media/Solitary Visual Learner.63f03723.png";